import { render, staticRenderFns } from "./CampanhaStatsRow.vue?vue&type=template&id=bc04ca1e"
import script from "./CampanhaStatsRow.vue?vue&type=script&lang=js"
export * from "./CampanhaStatsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports